// Live listener for an event's draws subcollection. Used by the admin panel,
// the venue display (for reveal sequencing), and the public live view (for
// the calmer "Winners" panel).

import { useEffect, useState } from "react";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import type { WithId, DrawDoc } from "../types";

export function useDraws(eventId: string | null | undefined): { draws: WithId<DrawDoc>[]; loaded: boolean } {
  const [draws, setDraws] = useState<WithId<DrawDoc>[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!eventId) return;
    setLoaded(false);
    const q = query(collection(db, "events", eventId, "draws"), orderBy("order"));
    return onSnapshot(q, (snap) => {
      setDraws(snap.docs.map((d) => ({ id: d.id, ...(d.data() as DrawDoc) })));
      setLoaded(true);
    });
  }, [eventId]);

  return { draws, loaded };
}
